<script>
import FormGroup from '@wielink-application/shared/vue/components/form/horizontal/form-group.vue'

export default FormGroup;
</script>